import { AudioDialogState } from 'app/components/Playlist/PlaylistRoomAudiosList/types';

export const audioDialogDefaultState: AudioDialogState = {
  open: false,
  audio: null,
};
